module.exports = __webpack_public_path__ + "img/10n.fad1439d.png";